module.exports = __webpack_public_path__ + "img/9.b5af05d1.png";